import { InjectionToken, inject } from '@angular/core';
import { Auth, authState, User } from '@angular/fire/auth';
import { Observable } from 'rxjs';

/**
 * Injection token that provides the Firebase auth state observable.
 * Using a token makes guards testable — tests override this with a mock observable.
 */
export const AUTH_STATE = new InjectionToken<Observable<User | null>>('AUTH_STATE', {
  providedIn: 'root',
  factory: () => authState(inject(Auth)),
});
